import React from "react";

const SubscriptionPaymentCard = (props) => {
  const { allPlans, authData } = props;

  return (
    <div className="SubscriptionList">
      {allPlans?.length > 0 &&
        allPlans.map((product) => {
          return (
            <div
              key={product.id}
              className={`sub-list-main-div px-20 ${
                authData?.profile?.subscriptionType == product.title
                  ? "active-border"
                  : ""
              }`}
            >
              <label className="plan-content">
                <div className="sub-list ">
                  <span className="sub-title">{product.title}</span>
                </div>
              </label>
              <h4 className={"sub-price"}>
                <span className="price-sign">&#163;</span>
                <span className="price">
                  {product.price}/<sub> Per Yearly</sub>
                </span>
              </h4>
            </div>
          );
        })}
    </div>
  );
};

export default SubscriptionPaymentCard;
